import { PlatformImages, SettingsPerCurrency } from '../types';

const getPromoItemByCurrency = (
  settingsPerCurrency: SettingsPerCurrency[],
  currentCurrency: string,
  language: string,
  platform: keyof SettingsPerCurrency,
  getImg: (imageLink?: string, imageLinkDark?: string) => string,
  item: string
): string | undefined => {
  const currentCurrencyConfig = settingsPerCurrency?.find(
    ({ currency }) => currency === currentCurrency
  );
  const currencyConfigForPlatform = currentCurrencyConfig?.[
    platform
  ] as PlatformImages;
  const { imageLink: currencyImage, imageLinkDark: currencyImageDark } =
    currencyConfigForPlatform || {};

  if (item === 'images') {
    const imagePerLanguage = currencyConfigForPlatform?.imagesPerLanguage?.find(
      (image) => image.language === language
    );
    const { imageLink: languageImage, imageLinkDark: languageImageDark } =
      imagePerLanguage || {};
    const promoLanguageImage =
      getImg(languageImage, languageImageDark) || languageImage;
    const promoCurrencyImage =
      getImg(currencyImage, currencyImageDark) || currencyImage;

    return promoLanguageImage || promoCurrencyImage;
  }

  return currentCurrencyConfig
    ? (currencyConfigForPlatform[item as keyof PlatformImages] as string)
    : undefined;
};

export default getPromoItemByCurrency;
